/**
 * Per-metric presentation: semantic tone + icon for every dashboard KPI key.
 * Purely visual — metric definitions/tooltips stay in metricTooltips.ts.
 *
 * Families: emerald money-in · orange money-out · amber credits ·
 * violet profit · blue players · rose risk/attention · slate neutral.
 */
import { AlertTriangle, Archive, ArrowDownCircle, ArrowLeftRight, ArrowUpCircle, Banknote, Clock, Coins, CreditCard, Landmark, Lock, Percent, PiggyBank, Receipt, Scale, ShieldAlert, ShoppingCart, Store, TrendingUp, Undo2, UserPlus, UserX, Users, Wallet, } from 'lucide-react';
export const METRIC_TONES = {
    // tier overview
    creditsSold: 'amber',
    creditsSoldCount: 'amber',
    creditsWithdrawnBack: 'amber',
    creditCost: 'orange',
    creditMargin: 'violet',
    netCashFlow: 'violet',
    usdIn: 'emerald',
    usdOut: 'orange',
    cashExpected: 'emerald',
    cashReceived: 'emerald',
    unsettledSettlementsCount: 'rose',
    outstandingDebt: 'rose',
    creditBalance: 'amber',
    usdBalanceNet: 'emerald',
    // network / players
    playerDeposits: 'emerald',
    playerDepositsCount: 'emerald',
    playerWithdrawals: 'orange',
    playerWithdrawalsCount: 'orange',
    activePlayers: 'blue',
    newPlayers: 'blue',
    // shop overview
    depositsOnline: 'emerald',
    depositsOnlineCount: 'emerald',
    depositsCounter: 'emerald',
    depositsCounterCount: 'emerald',
    redemptionsOnline: 'orange',
    redemptionsOnlineCount: 'orange',
    redemptionsCounter: 'orange',
    redemptionsCounterCount: 'orange',
    creditsIssued: 'amber',
    creditReserved: 'amber',
    creditAvailable: 'amber',
    avgDeposit: 'emerald',
    firstDepositConversionPct: 'blue',
    playerCreditLiability: 'slate',
    // shop operations
    openShifts: 'blue',
    discrepancyShifts: 'rose',
    discrepancyAmount: 'rose',
    noShowShifts: 'rose',
    pendingRedemptionApprovals: 'amber',
    cashierTransactionsCount: 'blue',
    cashierCashDelta: 'emerald',
    cashDropsTotal: 'emerald',
    cashDropsPendingCount: 'amber',
};
export const METRIC_ICONS = {
    creditsSold: Coins,
    creditsSoldCount: Receipt,
    creditsWithdrawnBack: Undo2,
    creditCost: ShoppingCart,
    creditMargin: TrendingUp,
    netCashFlow: ArrowLeftRight,
    usdIn: ArrowDownCircle,
    usdOut: ArrowUpCircle,
    cashExpected: Banknote,
    cashReceived: Banknote,
    unsettledSettlementsCount: Clock,
    outstandingDebt: AlertTriangle,
    creditBalance: Wallet,
    usdBalanceNet: Landmark,
    playerDeposits: ArrowDownCircle,
    playerDepositsCount: Receipt,
    playerWithdrawals: ArrowUpCircle,
    playerWithdrawalsCount: Receipt,
    activePlayers: Users,
    newPlayers: UserPlus,
    depositsOnline: CreditCard,
    depositsOnlineCount: Receipt,
    depositsCounter: Store,
    depositsCounterCount: Receipt,
    redemptionsOnline: ArrowUpCircle,
    redemptionsOnlineCount: Receipt,
    redemptionsCounter: Banknote,
    redemptionsCounterCount: Receipt,
    creditsIssued: Coins,
    creditReserved: Lock,
    creditAvailable: Wallet,
    avgDeposit: Scale,
    firstDepositConversionPct: Percent,
    playerCreditLiability: PiggyBank,
    openShifts: Clock,
    discrepancyShifts: AlertTriangle,
    discrepancyAmount: AlertTriangle,
    noShowShifts: UserX,
    pendingRedemptionApprovals: ShieldAlert,
    cashierTransactionsCount: Receipt,
    cashierCashDelta: Banknote,
    cashDropsTotal: Archive,
    cashDropsPendingCount: Archive,
};
export function metricTone(key) {
    return METRIC_TONES[key] || 'slate';
}
export function metricIcon(key) {
    return METRIC_ICONS[key];
}
